<template>
  <div :class="$style.root">
    <LayoutPageHeaderComponent
      :data="localizedData"
      :image="coverImageFromBlocks"
    />

    <CoreBlocksComponent
      v-if="blocks"
      :blocks="blocks"
    />

    <div :class="$style.list">
      <LayoutAccordionComponent>
        <template v-slot="slotProps">
          <PagesArchiveEntryComponent
            v-for="(entry, index) in localizedData?.entries"
            :key="entry.id"
            :entry="entry"
            :value="entry?.id"
            :active="slotProps?.activeId === entry?.id"
          />
        </template>
      </LayoutAccordionComponent>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data)))
const firstBlockIsCoverImage = computed(() => pageGetFirstBlocksIsCoverImage(localizedData.value?.blocks))
const coverImageFromBlocks = computed(() => pageGetFirstImageFromBlocks(localizedData.value?.blocks, firstBlockIsCoverImage.value))
const blocks = computed(() => pageGetBlocks(localizedData.value?.blocks, firstBlockIsCoverImage.value))
</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 3);
}

.list {
  composes: container--default from global;
}
</style>
